// extracted by mini-css-extract-plugin
export var section_title = "SectionTitle-module--section_title--+CkFn";
export var section_controll_buttons = "SectionTitle-module--section_controll_buttons--4YFOn";